import React from 'react';
import { Mui } from '@leap4/frontend';
import { ITrackedPublisher } from './appAdsLines.interface';

const { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } = Mui;

interface Props {
    publisher: ITrackedPublisher | null;
    activeLines?: number;
    removalRequests?: number;
    busy?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

/** Both list and settings actions must pass through this confirmation before any request. */
export const ArchivePublisherDialog: React.FC<Props> = ({ publisher, activeLines, removalRequests, busy, onCancel, onConfirm }) => (
    <Dialog open={!!publisher} onClose={() => { if (!busy) onCancel(); }} fullWidth maxWidth="xs"
        aria-labelledby="archive-publisher-title">
        <DialogTitle id="archive-publisher-title">Archive {publisher?.name}?</DialogTitle>
        <DialogContent dividers>
            <Typography variant="body2" gutterBottom>
                Are you sure you want to archive {publisher?.name} ({publisher?.domain})?
                It will leave the publishers list and stop being checked or included in bulk actions.
            </Typography>
            <Alert severity="info" sx={{ mt: 1 }}>
                Its settings, lines and change history will be kept. You can restore it from Publishers → Archive.
                {activeLines !== undefined && removalRequests !== undefined &&
                    ` This includes ${activeLines} tracked line(s) and ${removalRequests} old line(s).`}
            </Alert>
        </DialogContent>
        <DialogActions>
            <Button type="button" autoFocus disabled={busy} onClick={onCancel}>Cancel</Button>
            <Button type="button" variant="contained" color="warning" disabled={busy || !publisher}
                onClick={() => { if (publisher && !busy) onConfirm(); }}>
                {busy ? 'Archiving…' : 'Archive publisher'}
            </Button>
        </DialogActions>
    </Dialog>
);
